import { api } from '@/types/index.d'

export type WorkspaceImpactReportSearchForm =
  api.components['schemas']['WorkspaceImpactReportSearchForm']
export type WorkspaceImpactReportOverall =
  api.components['schemas']['WorkspaceImpactReportOverall']
export type WorkspaceImpactReportTemporalMetric =
  api.components['schemas']['WorkspaceImpactReportTemporalMetric']

export type ScopeWidgetsDataType = {
  active_projects: api.components['schemas']['WorkspaceImpactReportSingleMetricWithTrend']
  active_contributors: api.components['schemas']['WorkspaceImpactReportSingleMetricWithTrend']
  active_rules: api.components['schemas']['WorkspaceImpactReportSingleMetricWithTrend']
  detection_accuracy: api.components['schemas']['WorkspaceImpactReportSingleDoubleMetricWithTrend']
}

export type ImpactWidgetsDataType = {
  chart?: any
  data?: any
  id: string
  prefix?: any
  suffix?: any
  trends?: {
    config?: any
    style?: React.CSSProperties
    values: number[] | any[]
  }
  type?: 'per_month' | undefined
}

export enum Aggregation {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export enum ImpactWidget {
  ACTIVE_PROJECTS = 'active_projects',
  ACTIVE_CONTRIBUTORS = 'active_contributors',
  ACTIVE_RULES = 'active_rules',
  SCANS = 'total_reports',
  ISSUES_DETECTED = 'issues_detected',
  CODE_REVIEW_HOURS = 'code_review_hours',
  ISSUES_PREVENTED = 'issues_prevented',
  DETECTION_ACCURACY = 'detection_accuracy',
}

export function getWidgetValue({
  value,
  type,
  monthsSelected,
}: {
  value: number
  type?: 'per_month'
  monthsSelected?: number
  activeDevelopers?: number
}) {
  switch (type) {
    case 'per_month':
      return [value / monthsSelected]
    default:
      return typeof value !== 'undefined' ? [value] : []
  }
}
